export const slides = [
    'Make smart and cost-effective decisions on compliance by simplifying and automating your compliance process with Smartcomply',
    'Your all-in-one compliance solution suite helping you consolidate your compliance process end-to-end at a very affordable rate with monthly spaced payment.',
    'Integrate all your technology stack into Smartcomply and allow the platform continuously monitor your infrastructure and collect evidence for compliance.',
];

export const APP_COOKIES = [
    {
        domain: '__cf_bm',
        description:
            'This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.',
        type: 'Necessary',
    },
    {
        domain: '1P_Jar',
        description: 'Used for google font on the app.',
        type: 'Functional',
    },
    {
        domain: 'Crsftoken',
        description:
            'A CSRF token is a unique, secret, and unpredictable value that is generated by the server-side application and shared with the client.',
        type: 'Necessary',
    },
    {
        domain: 'session_id',
        description:
            "A session ID is a unique number that a Web site's server assigns a specific user for the duration of that user's visit (session)",
        type: 'Necessary',
    },
    {
        domain: '_fbn',
        description:
            'Used by Facebook Analytics to track user interactions and provide insights into website or app usage',
        type: 'Analytics',
    },
];

export const DATA_COLLECTION_LAW = [
    {
        purpose: ['purposeOfProcessing.a', 'purposeOfProcessing.b', 'purposeOfProcessing.c'],
        lawful_bases: 'lawfulBases.a',
    },
    {
        purpose: ['purposeOfProcessing.d'],
        lawful_bases: 'lawfulBases.b',
    },
    {
        purpose: ['purposeOfProcessing.e', 'purposeOfProcessing.f'],
        lawful_bases: 'lawfulBases.c',
    },
    {
        purpose: ['purposeOfProcessing.g'],
        lawful_bases: 'lawfulBases.d',
    },
    {
        purpose: ['purposeOfProcessing.h'],
        lawful_bases: 'lawfulBases.e',
    },
    {
        purpose: ['purposeOfProcessing.i'],
        lawful_bases: 'lawfulBases.f',
    },
    {
        purpose: ['purposeOfProcessing.j'],
        lawful_bases: 'lawfulBases.g',
    },
];
